import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventLocationFields from './EventLocationFields'

export const EventLocationCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EventLocationFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default EventLocationCreate
